import { LayoutOutlet } from "../../../Routes/Layout";
import { useLocation } from "react-router-dom";

export default function AuthLayout() {
  const location = useLocation();

  const productType = process.env.REACT_APP_PRODUCT_TYPE?.trim().toLowerCase();

  return (
    <>
      <div className="flex justify-center py-6">
        <div
          className={`w-full lg:w-1/2 lg:py-10 ${
            location.pathname === "/login" && "lg:mt-20"
          } px-4 md:px-14`}
        >
          <LayoutOutlet />
        </div>

        <div
          className={`hidden lg:block w-1/2 ${
            location.pathname === "/sign-up" && "h-[960px]"
          } px-4`}
        >
          <div className="relative bg-primary-darker rounded-3xl p-16 text-white overflow-hidden h-full">
            <div className="relative z-50">
              {productType === "ajosquad" && (
                <div className="space-y-3 px-3">
                  <h3 className="text-5xl font-medium leading-[64px]">
                    The simplest way to <br /> manage your finances.
                  </h3>

                  <p className="text-xl">
                    Empowering Financial Freedom Through Cooperative Savings
                  </p>
                </div>
              )}

              {productType === "ajohome" && (
                <div className="space-y-3 px-3">
                  <h3 className="text-5xl font-medium leading-[64px]">
                    The Power of Community Savings Applied to Canadian Real
                    Estate.
                  </h3>

                  <p className="text-xl">
                    The future of real estate isn't solo, it's collective.
                    AjoHomes is democratizing property ownership in Canada.
                  </p>
                </div>
              )}

              <div className="relative flex items-center justify-center pt-32">
                {productType === "ajosquad" && (
                  <img
                    src="./Dots.svg"
                    alt=""
                    className="absolute top-14 left-4"
                  />
                )}

                {productType === "ajosquad" && (
                  <img
                    src="./Border.svg"
                    alt=""
                    className="z-30 absolute top-[108px] right-1"
                  />
                )}

                <img
                  src={
                    productType === "ajosquad"
                      ? "./CreditCards.svg"
                      : "./ajo-home.png"
                  }
                  alt=""
                  className={
                    productType === "ajosquad"
                      ? "z-50 absolute -bottom-11 -right-14 w-[200px]"
                      : "absolute top-14 left-1"
                  }
                />

                {productType === "ajosquad" && (
                  <img
                    src={
                      productType === "ajosquad"
                        ? "./girl2.png"
                        : "./Ajohome_Signin_1.png"
                    }
                    alt=""
                    className="z-40 h-full w-[90%]"
                  />
                )}
              </div>
            </div>

            <div className="z-0">
              <img
                src="/Circle.svg"
                alt=""
                className="absolute bottom-0 w-full -m-16 rounded-md"
              />
              <img
                src="/Circle1.svg"
                alt=""
                className="absolute top-0 right-0"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
